import {
  DespatchAdvice,
  Invoice,
  OrderResponse,
  PatchRequest,
  WebEdiDto,
} from '../../../data/models'

// Function Overloads
// OrderResponse
export function prepareCompletePatchDto(
  newResponse: WebEdiDto<OrderResponse>,
  oldResponse: WebEdiDto<OrderResponse>,
): PatchRequest<WebEdiDto<OrderResponse>>

// DespatchAdvice
export function prepareCompletePatchDto(
  newResponse: WebEdiDto<DespatchAdvice>,
  oldResponse: WebEdiDto<DespatchAdvice>,
): PatchRequest<WebEdiDto<DespatchAdvice>>

// Invoice
export function prepareCompletePatchDto(
  newResponse: WebEdiDto<Invoice>,
  oldResponse: WebEdiDto<Invoice>,
): PatchRequest<WebEdiDto<Invoice>>

// Signature of the function
export function prepareCompletePatchDto(
  newResponse:
    | WebEdiDto<OrderResponse>
    | WebEdiDto<DespatchAdvice>
    | WebEdiDto<Invoice>,
  oldResponse:
    | WebEdiDto<OrderResponse>
    | WebEdiDto<DespatchAdvice>
    | WebEdiDto<Invoice>,
) {
  const patchDtos:
    | PatchRequest<WebEdiDto<OrderResponse>>
    | PatchRequest<WebEdiDto<DespatchAdvice>>
    | PatchRequest<WebEdiDto<Invoice>> = []

  // Confirmation code
  if (
    newResponse.Payload.ConfirmationCode !==
    oldResponse.Payload.ConfirmationCode
  ) {
    patchDtos.push({
      op: oldResponse.Payload.ConfirmationCode ? 'replace' : 'add',
      path: '/Payload/ConfirmationCode',
      value: newResponse.Payload.ConfirmationCode,
    })
  }

  // Confirmation date
  if (
    newResponse.Payload.ConfirmationDate !==
    oldResponse.Payload.ConfirmationDate
  ) {
    patchDtos.push({
      op: oldResponse.Payload.ConfirmationDate ? 'replace' : 'add',
      path: '/Payload/ConfirmationDate',
      value: newResponse.Payload.ConfirmationDate,
    })
  }

  // Confirmation reason code
  if (
    newResponse.Payload.ConfirmationReason?.Code !==
    oldResponse.Payload.ConfirmationReason?.Code
  ) {
    patchDtos.push({
      op: oldResponse.Payload.ConfirmationReason?.Code ? 'replace' : 'add',
      path: '/Payload/ConfirmationReason/Code',
      value: newResponse.Payload.ConfirmationReason?.Code,
    })
  }

  // Confirmation reason description
  if (
    newResponse.Payload.ConfirmationReason?.Description !==
    oldResponse.Payload.ConfirmationReason?.Description
  ) {
    patchDtos.push({
      op: oldResponse.Payload.ConfirmationReason?.Description
        ? 'replace'
        : 'add',
      path: '/Payload/ConfirmationReason/Description',
      value: newResponse.Payload.ConfirmationReason?.Description,
    })
  }

  return patchDtos
}
